'use client';
import React from 'react';
import { COOKIE_NAMES, Gender, GENDER } from '@/app/constants';
import { useTranslation } from 'next-i18next';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { setCookie } from 'cookies-next';
import { getCurrentLocalePath } from '@/app/helpers/locale';
import Link from 'next/link';

export function GenderButtonsDesktop({ domain, pageTags }: { domain: string; pageTags: string }) {
  const { t, i18n } = useTranslation('navigation');
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const localePath = getCurrentLocalePath(i18n.language);
  const showNicePath =
    (!/sales|online-shops|sale|marken/i.test(pathname || '') || (/marken/i.test(pathname || '') && !!pageTags)) &&
    localePath !== '/it';

  const showButton = pathname.indexOf('/sale/') > -1;

  function onGenderClick(gender: Gender) {
    const domainWithoutSubdomain = '.' + domain.split('.').slice(-2).join('.');

    if (gender) {
      setCookie(COOKIE_NAMES.GENDER, gender, {
        path: '/',
        domain: domainWithoutSubdomain,
        maxAge: 60 * 60 * 24 * 365,
      });
      //This invalidates client cache! DO NOT REMOVE THIS LINE!
    }

    if (searchParams && showButton) {
      const params = new URLSearchParams(searchParams);
      params.set('gender', gender);
      router.push(`${pathname}?${params.toString()}`);
    }
  }

  function returnHref(gender: Gender) {
    const params = new URLSearchParams(searchParams);
    params.set('gender', gender);

    const result = showNicePath
      ? `${pathname}${t(gender.toUpperCase()).toLowerCase()}/`
      : `${pathname}?${params.toString()}`;
    return result;
  }

  return (
    <div className="row">
      <div className="col-6" onClick={() => onGenderClick(GENDER.WOMAN)}>
        {showButton ? (
          <button className="btn btn-black-hover-light full-width button-gender" type="button">
            {t(GENDER.WOMAN.toUpperCase())}
          </button>
        ) : (
          <Link
            href={returnHref(GENDER.WOMAN)}
            className="btn btn-black-hover-light full-width button-gender"
            type="button">
            {t(GENDER.WOMAN.toUpperCase())}
          </Link>
        )}
      </div>
      <div className="col-6" onClick={() => onGenderClick(GENDER.MAN)}>
        {showButton ? (
          <button className="btn btn-black-hover-light full-width button-gender" type="button">
            {t(GENDER.MAN.toUpperCase())}
          </button>
        ) : (
          <Link
            href={returnHref(GENDER.MAN)}
            className="btn btn-black-hover-light full-width button-gender"
            type="button">
            {t(GENDER.MAN.toUpperCase())}
          </Link>
        )}
      </div>
    </div>
  );
}
